import styled from '@emotion/styled';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

type ColorOptionProps = {
  color: string;
  selected?: boolean;
};

const ColorOption = styled('div')<ColorOptionProps>(
  ({ theme, color }) => ({
    margin: 3,
    width: 24,
    height: 24,
    backgroundColor: color,
    borderRadius: 4,
    boxSizing: 'border-box',
    display: 'inline-block',
    cursor: 'pointer',
    transition: theme.transitions.create('all'),
    ':hover': {
      transform: 'scale(1.1)',
    },
  }),
  ({ theme, selected }) => {
    if (selected) {
      return {
        border: `1px solid ${theme.palette.action.active}`,
      };
    }
  },
  addHighContrastStyles(({ theme }) => ({
    border: `2px solid ${theme.palette.divider}`,
  })),
);

export default ColorOption;
